import { apiUrlV2 } from "../constants/apiUrl"
import rollbarLogger from "../utilities/rollbarLogger"

const initialState = {
  pushNotificationToken: null,
}

const createPushNotificationsSlice = (set, get) => ({
  createPushNotificationDevice: async (body) => {
    try {
      const response = await fetch(
        `${apiUrlV2}/push_notification_devices`,
        {
          headers: get().requestHeaders,
          method: 'POST',
          body: JSON.stringify(body)
        }
      )
      if (response.ok) {
        console.log('Push notifictions token created')
      }
    } catch (err) {
      get().logError('There was an error creating a push notification device.', err)
    }
  },
  setPushNotificationToken: (token) => {
    set((state) => ({ pushNotificationToken: token}))
  },
  resetPushNotificationsSlice: () => set(initialState)
})

export default createPushNotificationsSlice